import { createContext, useContext } from "react";

/** Organization identity paired with the active tenant QueryClient. */
export const TenantOrganizationIdContext = createContext<string | undefined>(undefined);

export function useTenantOrganizationId(): string | undefined {
    return useContext(TenantOrganizationIdContext);
}
